/**
 * useCalcError
 *
 * Owns the calc-engine error popup state that was previously class state
 * on FormViewer:
 *
 *   showCalcError(title, msg) — open the error popup
 *   hideCalcError()           — close the error popup
 *
 * State returned for render:
 *   calcErrorPopup  — boolean
 *   calcErrorTitle  — string
 *   calcErrorMsg    — string
 */
import { useState, useCallback } from 'react';

const useCalcError = () => {
  const [calcErrorPopup, setCalcErrorPopup] = useState(false);
  const [calcErrorTitle, setCalcErrorTitle] = useState('');
  const [calcErrorMsg, setCalcErrorMsg] = useState('');

  const showCalcError = useCallback((title, msg) => {
    setCalcErrorPopup(true);
    setCalcErrorTitle(title);
    setCalcErrorMsg(msg);
  }, []);

  const hideCalcError = useCallback(() => {
    setCalcErrorPopup(false);
    setCalcErrorTitle('');
    setCalcErrorMsg('');
  }, []);

  return { calcErrorPopup, calcErrorTitle, calcErrorMsg, showCalcError, hideCalcError };
};

export default useCalcError;
